// extracted by mini-css-extract-plugin
export default {"individualTabAliasesHeader":"ACbOYrNa8krrl9b7T4UC","individualTabAliases":"n0M7kjF9TYnuHRg1tXnj","individualTabAliasesAlias":"ohD8XZfgrYJ9L5tdE33Y"};